export const OPTION_LABEL_TH = {
  // bookingType
  hourly: 'รายชั่วโมง',
  halfDay: 'ครึ่งวัน',
  fullDay: 'เต็มวัน',

  // noise_level
  noise_level_Silent: 'เงียบมาก',
  'noise_level_Minimal-Noise': 'เสียงรบกวนน้อย',
  'noise_level_Moderate-Noise': 'เสียงปานกลาง',
  'noise_level_Noisy-Environment': 'ค่อนข้างเสียงดัง',
  parking_space: 'ที่จอดรถ',
  street: 'จอดริมถนน',
  nearby_lot: 'ลานจอดรถใกล้เคียง',
  on_property: 'ภายในพื้นที่',
  // connectivity
  connectivity_high_speed_internet: 'อินเทอร์เน็ตความเร็วสูง',
  connectivity_wifi_mesh: 'Wi-Fi Mesh ครอบคลุม',
  connectivity_fiber_internet: 'ไฟเบอร์เฉพาะ (Dedicated)',

  // amenity_accessibility
  amenity_street_access: 'เข้าถึงจากถนน',
  amenity_accessibility_elevator: 'ลิฟต์',
  amenity_freight_elevator: 'ลิฟต์ขนของ',
  amenity_accessibility_wheelchair: 'รองรับรถเข็น/ผู้พิการ',
  amenity_accessibility_stairs: 'มีบันได',
  amenity_accessibility_vehicle: 'เข้าถึงด้วยรถขนาดใหญ่',
  amenity_loading_bay: 'จุดโหลดของ (Loading Bay)',
  amenity_accessibility_ev_charger: 'ที่ชาร์จรถ EV',

  // Themes
  theme_Bohemian: 'โบฮีเมียน',
  theme_Bold: 'โดดเด่น',
  theme_Bright: 'สว่างสดใส',
  theme_Calm: 'สงบ',
  theme_Casual: 'สบาย ๆ',
  theme_Chic: 'เก๋มีสไตล์',
  theme_Classic: 'คลาสสิก',
  theme_Coastal: 'สไตล์ชายทะเล',
  theme_Colonial_architecture: 'สถาปัตยกรรมโคโลเนียล',
  theme_Contemporary_achitecture: 'สถาปัตยกรรมร่วมสมัย',
  theme_Cute: 'น่ารัก',
  theme_Dreamy: 'ชวนฝัน',
  theme_Edgy: 'แหวกแนว',
  theme_Elegant: 'หรูหรา',
  theme_Feminine: 'อ่อนหวาน',
  theme_Funky: 'สนุกมีเอกลักษณ์',
  theme_Glamorous: 'หรูหราสะดุดตา',
  theme_Greek: 'สไตล์กรีก',
  theme_Industrial: 'อินดัสเทรียล',
  theme_Laid_back: 'ผ่อนคลาย',
  theme_Mediterranean: 'เมดิเตอร์เรเนียน',
  'theme_Mid-century_modern': 'โมเดิร์นยุคกลางศตวรรษ',
  theme_Miminal: 'มินิมอล',
  theme_Modern: 'โมเดิร์น',
  theme_Natural: 'เป็นธรรมชาติ',
  theme_Outdoorsy: 'สไตล์กลางแจ้ง',
  theme_Polished: 'เรียบเนี้ยบ',
  theme_Quirky: 'แปลกมีเสน่ห์',
  theme_Retro: 'เรโทร',
  theme_Rustic: 'รัสติก / บ้านชนบท',
  theme_Sexy: 'เซ็กซี่',
  theme_Sleek: 'เรียบหรูทันสมัย',
  theme_Sophisticated: 'หรูมีระดับ',
  theme_Southern: 'สไตล์ภาคใต้',
  theme_Thai_traditional: 'ไทยดั้งเดิม',
  theme_Traditional: 'ดั้งเดิม',
  theme_Tribal: 'ชนเผ่า',
  theme_Urban: 'เมือง',
  theme_Vibrant: 'มีชีวิตชีวา',
  theme_Vintage: 'วินเทจ',
  theme_Warm: 'อบอุ่น',
  theme_Whimsical: 'แฟนตาซี',
  theme_Youthful: 'สดใสวัยรุ่น',

  // Amenities
  amenity_air_conditioning: 'เครื่องปรับอากาศ',
  amenity_kitchen: 'ห้องครัว',
  wifi: 'อินเทอร์เน็ตไร้สาย (Wi-Fi)',
  on_site_food_and_drinks: 'มีอาหารและเครื่องดื่มในสถานที่',
  dining_area: 'พื้นที่รับประทานอาหาร',
  meeting_room: 'ห้องประชุม',
  front_desk: 'เคาน์เตอร์ต้อนรับ',
  lockers_storage: 'ตู้เก็บของ / พื้นที่เก็บของ',
  restrooms: 'ห้องน้ำ',
  shower: 'ห้องอาบน้ำ',
  refrigerator: 'ตู้เย็น',
  coffeemaker: 'เครื่องชงกาแฟ',
  tv: 'โทรทัศน์',
  heating: 'ระบบทำความร้อน',
  closet: 'ตู้เสื้อผ้า',
  hair_makeup_room: 'ห้องแต่งหน้าและทำผม',

  // Studio / Production Features
  feature_green_screen: 'กรีนสกรีน',
  feature_cyclorama_wall: 'ผนังไซโคลรามา',
  feature_soundproof: 'กันเสียง',
  feature_acoustic_panels: 'แผงดูดซับเสียง',
  feature_lighting_grid: 'โครงไฟ',
  feature_lighting_grip: 'อุปกรณ์ไฟและกริป',
  feature_blackout_curtains: 'ผ้าม่านกันแสง',
  feature_fog_machine: 'เครื่องทำหมอก',
  feature_playback: 'อุปกรณ์เพลย์แบ็ก',
  feature_wind_machine: 'เครื่องสร้างลม',
  feature_standing_sets: 'ฉากถาวร',
  feature_viewing: 'พื้นที่รับชม / ห้องดูงาน',
  feature_props: 'พร็อพประกอบฉาก',
  feature_kitchen: 'ห้องครัว',
  feature_outdoor_space: 'พื้นที่กลางแจ้ง',
  feature_production_offices: 'สำนักงานกองถ่าย',
  feature_rooftop_view: 'วิวจากดาดฟ้า',
  feature_shower: 'ห้องอาบน้ำ',
  feature_wardrobe_room: 'ห้องแต่งตัว / วอร์ดโรว์บ',
  feature_black_box: 'แบล็คบ็อกซ์',
  feature_film_darkroom: 'ห้องล้างฟิล์ม',
  feature_crew_dining_area: 'พื้นที่รับประทานอาหารทีมงาน',
  feature_conference_room: 'ห้องประชุม',
  feature_hair_makeup_room: 'ห้องแต่งหน้าและทำผม',
  feature_large_vehicle_access: 'รองรับรถขนาดใหญ่',
  feature_scissor_lift: 'ลิฟต์กรรไกร',
  feature_paper_backdrops: 'ฉากกระดาษ',
  feature_crew_restrooms: 'ห้องน้ำสำหรับทีมงาน',

  // Wall
  wall_brick: 'ผนังอิฐ',
  wall_concrete: 'ผนังคอนกรีต',
  wall_white: 'ผนังสีขาว',
  wall_whitewashed: 'ผนังปูนเปลือยสีขาว',
  wall_wood_paneled: 'ผนังไม้',
  wall_colored: 'ผนังสี',
  wall_graffiti: 'ผนังกราฟฟิตี้',
  wall_glass: 'ผนังกระจก',
  wall_mirrored: 'ผนังกระจกเงา',
  wall_stone: 'ผนังหิน',
  wall_textured: 'ผนังพื้นผิวพิเศษ',
  wall_tiled: 'ผนังกระเบื้อง',
  wall_wallpaper: 'ผนังวอลเปเปอร์',

  // Floor
  floor_carpet: 'พื้นพรม',
  floor_checker_tiles: 'พื้นกระเบื้องลายตาราง',
  floor_concrete: 'พื้นคอนกรีต',
  floor_dark_wood: 'พื้นไม้สีเข้ม',
  floor_light_wood: 'พื้นไม้สีอ่อน / พื้นไม้ฟอกสี',
  floor_linoleum: 'พื้นลิโนเลียม',
  floor_marble: 'พื้นหินอ่อน',
  floor_stone: 'พื้นหิน',
  floor_tiles: 'พื้นกระเบื้อง',
  floor_wood: 'พื้นไม้',

  // Windows
  window_floor_to_ceiling: 'หน้าต่างกระจกสูงจรดเพดาน',
  window_picture: 'หน้าต่างบานตาย / หน้าต่างกระจกนิ่ง',
  window_skylights: 'ช่องแสง / หน้าต่างสกายไลท์',
  window_stained_glass: 'หน้าต่างกระจกสี',
  window_sash: 'หน้าต่างบานเลื่อนขึ้น-ลง',
  window_slider: 'หน้าต่างบานเลื่อน',
  window_transom: 'หน้าต่างทรานซอม (เหนือประตู/หน้าต่าง)',
  window_hinged_casement: 'หน้าต่างบานเปิด / บานกระทุ้ง',

  // Power & security
  'standard-outlets': 'ปลั๊กไฟมาตรฐาน',
  'high-voltage-power': 'ไฟฟ้าแรงดันสูง',
  'three-phase-power': 'ไฟฟ้า 3 เฟส',
  backup_generators: 'เครื่องกำเนิดไฟฟ้าสำรอง',
  no_power: 'ไม่มีไฟฟ้า',

  security_onsite: 'มี รปภ. ในสถานที่',
  security_cctv: 'กล้องวงจรปิด (CCTV)',
  security_secured_entrance: 'ทางเข้าออกมีระบบรักษาความปลอดภัย',
  security_fire_safety: 'อุปกรณ์ป้องกันอัคคีภัย',
  // CATEGORY_LABEL

  studio_photography: 'สตูดิโอถ่ายภาพ',
  studio_videography: 'สตูดิโอถ่ายวิดีโอ',
  studio_green_screen: 'สตูดิโอกรีนสกรีน',
  studio_cyclorama: 'สตูดิโอไซโคลรามา',
  studio_podcast_voiceover: 'สตูดิโอพอดแคสต์และพากย์เสียง',
  studio_virtual_production: 'สตูดิโอเวอร์ชวลโปรดักชัน',
  studio_other: 'อื่น ๆ',

  urban: 'โลเคชันเมือง',
  urban_rooftop: 'ดาดฟ้า',
  urban_industrial_warehouse: 'โกดังอุตสาหกรรม',
  urban_abandoned_building: 'อาคารร้าง',
  urban_luxury_penthouse: 'เพนท์เฮาส์หรู',
  urban_office_space: 'พื้นที่สำนักงาน',
  urban_coffee_shop: 'ร้านกาแฟและคาเฟ่',
  urban_restaurant_bar: 'ร้านอาหารและบาร์',
  urban_underground_parking: 'ลานจอดรถใต้ดิน',
  urban_other: 'อื่น ๆ',

  residential: 'ที่พักอาศัย',
  residential_modern_home: 'บ้านสมัยใหม่',
  residential_traditional_home: 'บ้านแบบดั้งเดิม',
  residential_luxury_villa: 'วิลล่าหรู',
  residential_cabin_lodge: 'กระท่อมและลอดจ์',
  residential_loft_apartment: 'อพาร์ตเมนต์ลอฟต์',
  residential_other: 'อื่น ๆ',

  outdoor: 'โลเคชันกลางแจ้งและธรรมชาติ',

  outdoor_beach: 'ชายหาด',
  outdoor_forest_jungle: 'ป่าและป่าดงดิบ',
  outdoor_mountain_cliff: 'ภูเขาและหน้าผา',
  outdoor_lake_river: 'ทะเลสาบและแม่น้ำ',
  outdoor_desert_dune: 'ทะเลทรายและเนินทราย',
  outdoor_national_park_waterfall: 'อุทยานแห่งชาติและน้ำตก',
  outdoor_other: 'อื่น ๆ',

  sports: 'โลเคชันกีฬาและนันทนาการ',

  sports_gym_fitness: 'ยิมและศูนย์ฟิตเนส',
  sports_stadium_arena: 'สนามกีฬาและอารีนา',
  sports_martial_arts_dojo: 'โดโจศิลปะการต่อสู้',
  sports_swimming_pool: 'สระว่ายน้ำ',
  sports_skate_park: 'สเกตพาร์ก',
  sports_tennis_basketball_court: 'สนามเทนนิสและสนามบาสเกตบอล',
  sports_other: 'อื่น ๆ',

  unique: 'โลเคชันพิเศษและเฉพาะทาง',

  unique_airport_hangar: 'สนามบินและโรงเก็บเครื่องบิน',
  unique_train_subway_station: 'สถานีรถไฟและรถไฟใต้ดิน',
  unique_carnival_amusement: 'งานคาร์นิวัลและสวนสนุก',
  unique_boat_yacht: 'เรือและเรือยอชต์',
  unique_farm_ranch: 'ฟาร์มและไร่',
  unique_underground_bunker: 'บังเกอร์ใต้ดิน',
  unique_cemetery: 'สุสาน',
  unique_science_lab: 'ห้องปฏิบัติการวิทยาศาสตร์',
  unique_prison_police_station: 'เรือนจำและสถานีตำรวจ',
  unique_castle_mansion: 'ปราสาทและคฤหาสน์',
  unique_other: 'อื่น ๆ',

  cultural: 'โลเคชันวัฒนธรรมและประวัติศาสตร์',

  cultural_Museums_Art_Galleries: 'พิพิธภัณฑ์และหอศิลป์',
  cultural_Libraries: 'หอสมุดและห้องสมุด',
  cultural_Temples_Shrines: 'วัดและศาลเจ้า',
  cultural_mosques: 'มัสยิด',
  cultural_Abandoned_Ruins: 'โบราณสถานร้าง',
  cultural_Theaters_Opera_Houses: 'โรงละครและโอเปร่าเฮาส์',
  cultural_other: 'อื่น ๆ',

  transport: 'โลเคชันยานพาหนะและการขนส่ง',

  transport_cars_motorcycles: 'รถยนต์และรถจักรยานยนต์',
  transport_train_set: 'ชุดฉากรถไฟ',
  transport_boats_yachts: 'เรือและเรือยอชต์',
  transport_airplane_set: 'ชุดฉากเครื่องบิน',
  transport_private_jet_helicopter: 'เครื่องบินเจ็ตส่วนตัวและเฮลิคอปเตอร์',
  transport_other: 'อื่น ๆ',
  other: 'อื่น ๆ',

  parking_space: 'ที่จอดรถ',

  studio: 'สตูดิโอ',
  parking_spots: 'จำนวนที่จอดรถ (ถ้ามี)',
  feature_films: 'ภาพยนตร์ยาว (Feature Films)',
  tv_commercial: 'โฆษณาทางโทรทัศน์',
  social_media_advertisement: 'โฆษณาสื่อสังคมออนไลน์',
  interest_documentary: 'สารคดี',
  interest_music: 'มิวสิกวิดีโอ',
  fashion_shoot: 'แฟชั่นถ่ายแบบ',
  tv_series: 'ซีรีส์โทรทัศน์',
  product_promo: 'โปรโมตสินค้า',
  photography: 'การถ่ายภาพ',

  hourly: 'รายชั่วโมง',
  halfDay: 'ครึ่งวัน',
  fullDay: 'เต็มวัน',
  bookingType: 'รูปแบบการจอง',
  available: 'พร้อมใช้งาน',
  not_available: 'ไม่พร้อมใช้งาน',
};

export const FIELD_HEADING_TH = {
  bookingType: 'ประเภทการจอง',
  noise_level: 'ระดับเสียง',
  connectivity: 'การเชื่อมต่อ',
  amenity_accessibility: 'การเข้าถึงและโลจิสติกส์',
  rec_style: 'สไตล์ยอดนิยม – พื้นที่นันทนาการและเฉพาะทาง',
  natural_style: 'สไตล์ยอดนิยม – ธรรมชาติและกลางแจ้ง',
  indoor_style: 'สไตล์ยอดนิยม – พื้นที่ในอาคารตามการใช้งาน',
  feature_outdoor: 'องค์ประกอบกลางแจ้งและธรรมชาติ',

  amenities: 'สิ่งอำนวยความสะดวก',
  amenity_services: 'บริการ',
  floor: 'พื้น',
  windows: 'หน้าต่าง',
  wall: 'ผนัง',
  studio_and_production_features: 'คุณสมบัติการผลิต',
  studio_style: 'สไตล์สตูดิโอ',
  crew_rules: 'กฎสำหรับทีมงาน',
  parking_accessibility: 'ที่จอดรถและการเข้าถึง',
  availability: 'เวลาทำการ',
  studio: 'สตูดิโอ',
  theme: 'ธีม',
  property_size_m2: 'ขนาดพื้นที่ (ตร.ม.)',
  ceiling_height: 'ความสูงเพดาน (ซม.)',
  power_supply: 'ระบบไฟฟ้า',
  safety_and_security: 'ความปลอดภัย',
  number_bedrooms: 'จำนวนห้องนอน',
  number_bathrooms: 'จำนวนห้องน้ำ',
  main_floor_number: 'ชั้นหลัก (ถ้ามี)',
  parking_spots: 'จำนวนที่จอดรถ (ถ้ามี)',
  parking_space: 'ที่จอดรถ',
  loading_dock: 'ทางเข้าท่าเทียบสินค้า',
  access_options: 'ตัวเลือกการเข้าถึง',

  company: 'บริษัท',
  Occupation: 'อาชีพ',
  nationality: 'สัญชาติ',

  typical_cast_crew_size: 'ขนาดทีมงานและนักแสดงโดยทั่วไป',

  interest: 'ความสนใจและความเชี่ยวชาญ',

  languages: 'ภาษา',

  occupation: 'อาชีพ',

  bookingType: 'รูปแบบการจอง',
};

export const GROUP_HEADING_TH = {
  Amenities: 'สิ่งอำนวยความสะดวก',
  'Studio Features': 'คุณสมบัติสตูดิโอ',
  'Parking & Accessibility': 'ที่จอดรถและการเข้าถึง',
};
